import React from 'react'

const AbstractingAndIndexing = () => {
  return (
    <div>
      <h2 className="fw-bold text-blue font-size-21">Abstracting & Indexing</h2>

      <p>
        The International Journal of Interdisciplinary Studies and System Science (IJISSS) is committed to broad dissemination and discoverability of its published research. IJISSS is an open-access, peer-reviewed journal and we are actively pursuing inclusion in major abstracting and indexing services to increase the visibility, accessibility, and citation of authors’ work.
      </p>

      <p>Current status:</p>
      <ul>
        <li>IJISSS is a newly launched title and is in the process of applying for indexing and archiving services.</li>
        <li>The journal has secured permanent identifiers (ISSN) and is registering DOIs for articles via CrossRef to ensure persistent linking and citation tracking.</li>
      </ul>

      <p>Indexing and archiving services we are targeting:</p>
      <ul>
        
        <li>DOAJ (Directory of Open Access Journals)</li>
        <li>Google Scholar</li>
        <li>CrossRef (DOI registration) & CrossMark</li>
        <li>EBSCO & ProQuest</li>
        <li>SSRN (Social Science Research Network) / RePEc for eligible social science content</li>
        <li>ERIC (for education-related contributions)</li>
        <li>LOCKSS / CLOCKSS / Portico for digital preservation</li>
        <li>Scopus (Under Process)</li>
        <li>Web of Science (including Emerging Sources Citation Index where applicable) (Under Process)</li>
      </ul>

      <p>
        <strong>Notes for authors:</strong> indexation is a multi-stage process that can take several months. We will update the journal website with each successful inclusion and notify authors whose articles become covered by a database. Inclusion in specific databases depends on each service’s policies and acceptance criteria.
      </p>

      <p>
        If you have questions about indexing, DOI assignment, or how to maximize discoverability of your paper (metadata, keywords, ORCID linking), please contact the editorial office at <em>editor@ijisss.org</em>.
      </p>
    </div>
  )
}

export default AbstractingAndIndexing
